import { render, staticRenderFns } from "./DealSalesDeliverySignage.vue?vue&type=template&id=651ae9e8&scoped=true"
import script from "./DealSalesDeliverySignage.vue?vue&type=script&lang=js"
export * from "./DealSalesDeliverySignage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651ae9e8",
  null
  
)

export default component.exports